import { ifElse, always } from 'ramda';
import { isNilOrEmpty } from './ramda_utils';

export const newEditPageName = (pageName: string, id?: number | string) =>
  ifElse(isNilOrEmpty, always(`${pageName}_NEW`), always(`${pageName}_EDIT`))(id);
